<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div mdbModal #viewTicketModal="mdbModal" class="modal fade" id="viewTicketModal" style="
  pointer-events: none;" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}" style="z-index: 99 !important;">
    <div class="modal-dialog modal-fluid" role="document" style="width: 90%; ">
        <div class="modal-content">
            <div class="row ka-em-labels">
                <div class="col-md-2 ka-em-tkt-label">Ticket Id</div>
                <div class="col-md-2 ka-em-tkt-label">Status</div>
                <div class="col-md-2 ka-em-tkt-label">Opened on / DOR</div>
                <div class="col-md-2 ka-em-tkt-label">Assigned To</div>
                <div class="col-md-2 ka-em-tkt-label">Remainder</div>
                <div class="col-md-2">
                    <button type="button" class="close" style="right: 62px !important;" data-dismiss="modal"
                        aria-label="Close" (click)="closeViewTicketModal()">
                        <span aria-hidden="true" class="">&times;</span>
                    </button>
                </div>
            </div>
            <div class="row ka-em-labels">
                <div class="col-md-2 ka-em-tkt-value">{{basicTicketInformation['TicketID']}}</div>
                <div class="col-md-2 ka-em-tkt-value">{{basicTicketInformation['TicketStatus']}}</div>
                <div class="col-md-2 ka-em-tkt-value">{{basicTicketInformation['TicketOpenedOn']}}</div>
                <div class="col-md-2 ka-em-tkt-value">{{basicTicketInformation['EmpName']}}</div>
                <div class="col-md-2 ka-em-remainder"
                    *ngIf="basicTicketInformation['ReminderDate']!=null && basicTicketInformation['ReminderDate']!=''"
                    (click)="createRemainder()">{{basicTicketInformation['ReminderDate']}}</div>
                <div class="col-md-2 ka-em-tkt-create-remainder"
                    *ngIf="basicTicketInformation['ReminderDate']===null || basicTicketInformation['ReminderDate']===''"
                    (click)="createRemainder()">Create Remainder</div>
                <div class="col-md-2"></div>
            </div>
            <hr>
            <div class="row" *ngIf="ticketViewTab === 1">
                <div class="col-md-2">
                    <span *ngIf="basicTicketInformation['CustomerApplicationPhoto']===null"> <img
                            src="../../../../assets/img/ticket/Rectangle 781@2x.jpg" class="ka-em-no-img"> </span>
                    <span *ngIf="basicTicketInformation['CustomerApplicationPhoto']!=null" style="cursor: pointer;"
                        (click)="showImagePreview(custId)"> <img
                            src="{{basicTicketInformation['CustomerApplicationPhoto']}}" class="ka-em-no-img"> </span>
                </div>
                <div class="col-md-3">
                    <div class="row">
                        <span class="ka-em-info-values">{{basicTicketInformation['Cust_Name']}}</span> <span style="cursor: pointer;"
                          (click)="navigateToViewProfile(basicTicketInformation['ProfileID'])"  class="ka-em-tkt-info-profileid" [ngStyle]="{'color':getProfileTypeColour(basicTicketInformation['SubscriptionServiceTypeId'])}">({{getModifiedProfile(basicTicketInformation['ProfileID'],basicTicketInformation['SubscriptionServiceTypeId'])}})</span>
                    </div>
                    <div class="row">
                        <span class="ka-em-create-offer"
                            *ngIf="(basicTicketInformation['offersCount']===0 || basicTicketInformation['offersCount']===null) && loginData?.isAdmin === 1"
                            (click)="createOffers(basicTicketInformation['ProfileID'])">Create Offers</span>
                        <span class="ka-em-create-offer-second"
                            *ngIf="(basicTicketInformation['offersCount']===0 || basicTicketInformation['offersCount']===null) && loginData?.isAdmin !== 1"
                            >Create Offers</span>
                        <span class="ka-em-create-offer" *ngIf="basicTicketInformation['offersCount'] > 0 "
                            (click)="viewOffers(basicTicketInformation['ProfileID'])">View Offers</span>

                    </div>

                    <div class="row">
                        <span class="ka-em-mobile-not-verified" *ngIf="basicTicketInformation['PaidSatus']==1"
                            style="padding-left: 8% !important;" (click)="navigateToProfileDetails()">Payment
                            Details</span>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="row">
                        <span class="ka-em-info-values">Mobile :</span>
                        <span class="ka-em-tkt-info-profileid" *ngIf="tracking">{{basicTicketInformation['number']}}</span>
                        <span class="ka-em-tkt-info-profileid text-danger" *ngIf="!tracking" (click)="viewEmailOrMobile('call',basicTicketInformation['number'],custId,basicTicketInformation['EmpID'])">View Contact</span>
                        <!-- <span *ngIf="basicTicketInformation['ismobileverified']===1">
                            <img src="../../../../assets/img/ticket/icon.svg" class="ka-em-no-mobile-verified">
                        </span> -->
                        <span
                            *ngIf="basicTicketInformation['ismobileverified']===null || basicTicketInformation['ismobileverified']===0"><i
                                class="far fa-check-circle"></i></span>
                        <span
                            *ngIf="basicTicketInformation['ismobileverified']!=null &&  basicTicketInformation['ismobileverified']===1"
                            style="color: green;"><i class="far fa-check-circle"></i></span>
                    </div>
                    <div class="row">
                        <span class="ka-em-info-values">Mobile Verified On :</span> <span
                            *ngIf="basicTicketInformation['ismobileverified']===1"
                            class="ka-em-mobile-verified">{{basicTicketInformation['mobileverifieddate']}}</span>

                        <span *ngIf="basicTicketInformation['ismobileverified']!=1" class="ka-em-mobile-not-verified"
                            (click)="verifyMobileNumber()">Verify Mobile</span>
                    </div>


                </div>
                <div class="col-md-4">
                    <div class="row">
                        <span class="ka-em-info-email-value">Email :</span>
                        <!-- <span class="ka-em-tkt-info-profileid">{{basicTicketInformation['email']}}</span> -->
                        <span class="ka-em-tkt-info-profileid" *ngIf="tracking">{{basicTicketInformation['email']}}</span>
                        <span class="ka-em-tkt-info-profileid text-danger" *ngIf="!tracking" (click)="viewEmailOrMobile('email',basicTicketInformation['email'],custId,basicTicketInformation['EmpID'])">View Contact</span>
                        <!-- <span *ngIf="basicTicketInformation['isemailverified']===1">
                            <img src="../../../../assets/img/ticket/icon.svg" class="ka-em-no-mobile-verified">
                        </span> -->
                        <span
                            *ngIf="basicTicketInformation['isemailverified']===null || basicTicketInformation['isemailverified']===0"><i
                                class="far fa-check-circle"></i></span>
                        <span
                            *ngIf="basicTicketInformation['isemailverified']!=null &&  basicTicketInformation['isemailverified']===1"
                            style="color: green;"><i class="far fa-check-circle"></i></span>
                    </div>
                    <div class="row">
                        <span class="ka-em-info-values">Email Verified On :</span> <span
                            *ngIf="basicTicketInformation['isemailverified']===1"
                            class="ka-em-mobile-verified">{{basicTicketInformation['emailverifieddate']}}</span>
                        <span *ngIf="basicTicketInformation['isemailverified']!=1" class="ka-em-mobile-not-verified"
                            (click)="verifyEmail()">Verify Email</span>
                    </div>

                </div>
            </div>
            <div class="row ka-em-no-data" *ngIf="noDataList.length>0">
                <div class="col-md-3" *ngFor="let eachValue of noDataList">
                    <span class="ka-em-no-data-value" *ngIf="eachValue!=''" style="cursor: pointer;"
                    (click)="openEditViewPage(basicTicketInformation,eachValue)">NO {{eachValue}} Details</span>
                </div>
            </div>
            <div style="padding-top: 0%;" *ngIf="ticketViewTab === 1">
                <div class="ka-em-tkt-separator"></div>
            </div>
            <div class="row">
                <div class="profileHolder">

                    <div class="tabs-button-holder mt-3 mb-3" style="margin: auto;">
                        <a class="tWhiteButton ka-white-button btn ka-filled-button"
                            [ngClass]="ticketViewTab === 1 ? 'active' : ''" (click)="changeTab(1)">View</a>
                        <a class="tWhiteButton ka-white-button btn ka-filled-button"
                            [ngClass]="ticketViewTab === 2 ? 'active' : ''" (click)="changeTab(2)">Incoming Call</a>
                        <a class="tWhiteButton ka-white-button btn ka-filled-button"
                            [ngClass]="ticketViewTab === 3 ? 'active' : ''" (click)="changeTab(3)">Outgoing Call</a>
                        <a class="tWhiteButton ka-white-button btn ka-filled-button"
                            [ngClass]="ticketViewTab === 4 ? 'active' : ''" (click)="changeTab(4)">Internal Memo</a>
                        <a class="tWhiteButton ka-white-button btn ka-filled-button"
                            [ngClass]="ticketViewTab === 5 ? 'active' : ''" (click)="changeTab(5)">Close Ticket</a>
                    </div>
                </div>
            </div>

            <div class="ka-em-tkt-view-mode">
                <div class="ka-em-view-content" id="tab-content" *ngIf="ticketViewTab == 1">
                    <div *ngFor="let eachTicket of ticketHistoryList">
                        <div class="ka-em-hstr-label" [ngStyle]="{'color':getTicketHistoryTypeColour(eachTicket['TicketType'])}">
                            <span
                                >{{eachTicket['TicketType']}}</span>
                            Done on<span style="padding-left: 1%;">{{eachTicket['ReplyDate']}}</span>
                        </div>
                        <div class="row ka-tkt-emp-name">
                            <div class="col">
                                <span>Employee Name</span>
                            </div>
                            <div class="col">
                                <span>{{eachTicket['NAME']}}</span>
                            </div>
                            <div class="col"></div>
                        </div>
                        <div class="row ka-tkt-emp-name">
                            <div class="col">
                                <span>Call Status</span>
                            </div>
                            <div class="col">
                                <span>{{eachTicket['CallStatus']}}</span>
                            </div>
                            <div class="col"></div>
                        </div>
                        <div class="row ka-tkt-emp-name">
                            <div class="col">
                                <span>Call Received By</span>
                            </div>
                            <div class="col">
                                <span>{{eachTicket['CallReceivedBy']}}</span>
                            </div>
                            <div class="col"></div>
                        </div>
                        <div class="row ka-tkt-emp-name">
                            <div class="col">
                                <span>Comments</span>
                            </div>
                            <div class="col">
                            </div>
                            <div class="col"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-12  ka-em-txt-description">
                                <span>
                                    {{eachTicket['ReplyDesc']}}
                                </span>
                            </div>

                        </div>
                        <div class="ka-em-boder-line"></div>

                    </div>
                    <div class="row">
                        <div class="col-md-12" style="text-align: center;">
                            <p style="cursor: pointer;" (click)="closeViewTicketModal()"> <span>Close</span></p>
                        </div>
                    </div>
                </div>
                <div class="row ka-em-view-content" id="tab-content" *ngIf="ticketViewTab == 2"
                    style="height:auto !important;">
                    <form class="" [formGroup]="incomingCallForm">

                        <!-- <p class="h4 mb-4 ka-section-head-text ka-login-header-text">Admin Login</p> -->

                        <!-- Name -->
                        <div class="row mt-2">
                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="defaultContactFormName">
                                    Call Received From<span class="ka-em-requried">*</span></label>
                                <select #relationSelect class="browser-default custom-select" id="relationID"
                                    formControlName="relationID" (change)="selectedRelation(relationSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of callsFrom" [ngValue]="call.value">
                                        <p>{{call['label']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="incomingCallForm.controls['relationID'].errors && !incomingCallForm.controls['relationID'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!incomingCallForm.controls['relationID'].errors.required">Call
                                        Received
                                        From is required.</div>

                                </div>
                            </div>
                            <div class="col-md-6 ">

                                <label class="text-left ka-float-left " for="relationName">Enter
                                    Relation<span class="ka-em-requried">*</span></label>
                                <input type="text" formControlName="relationName" id="relationName" mdbInput
                                    class="form-control " placeholder="Enter Relation">
                                <div *ngIf="incomingCallForm.controls['relationName'].errors && !incomingCallForm.controls['relationName'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!incomingCallForm.controls['relationName'].errors.required">Relation
                                        Name
                                        is required.</div>
                                </div>
                            </div>

                        </div>

                        <div class="row mt-2">
                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="defaulvoiceCallType">
                                    Voice Call Type<span class="ka-em-requried">*</span></label>
                                <select #incomingVoiceCallSelect class="browser-default custom-select"
                                    id="voiceCallType" formControlName="voiceCallType"
                                    (change)="selectedVoiceCallType(incomingVoiceCallSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of voiceCallsType" [ngValue]="call.value">
                                        <p>{{call['label']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="incomingCallForm.controls['voiceCallType'].errors && !incomingCallForm.controls['voiceCallType'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!incomingCallForm.controls['voiceCallType'].errors.required">Call
                                        Voice is required.</div>

                                </div>
                            </div>

                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="defaulphoneNum">
                                    Call Telephone Number<span class="ka-em-requried">*</span></label>
                                <select #incomeTelephoneSelect class="browser-default custom-select" id="phoneNum"
                                    formControlName="phoneNum"
                                    (change)="selectedIncomingTelePhone(incomeTelephoneSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let telePhone of callTelephoneNumbers" [ngValue]="telePhone">
                                        <p>{{hideFewNumbersInMobileNum(telePhone)}}</p>
                                    </option>
                                </select>
                                <div *ngIf="incomingCallForm.controls['phoneNum'].errors && !incomingCallForm.controls['phoneNum'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!incomingCallForm.controls['phoneNum'].errors.required">Call
                                        Telephone Number required.</div>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <label class="text-left ka-float-left " for="defaulvoiceCallType">
                                    Call Response Type</label>
                                <select #incomingVoiceCallSelect
                                    class="browser-default custom-select"
                                    formControlName="MarketingTicketStatus">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of responseTypeArray"
                                        [ngValue]="call.id">
                                        <p>{{call['value']}}</p>
                                    </option>
                                </select>
                                <!-- <div *ngIf="incomingCallForm.controls['MarketingTicketStatus'].errors && !outGoingCallForm.controls['MarketingTicketStatus'].pristine "
                                    class="error-msg1">
                                    <div
                                        [hidden]="!incomingCallForm.controls['MarketingTicketStatus'].errors.required">
                                        Response Cal is required.</div>

                                </div> -->
                            </div>
                            <div class="col-md-6 customMultiSelect">

                            </div>


                        </div>

                        <div class="row mt-2" style="padding-left: 2%;">

                            <label class="text-left ka-float-left " for="defaultContactFormName">Call Discussion<span
                                    class="ka-em-requried">*</span></label>

                            <textarea type="text" formControlName="callDiscussion" class="form-control" rows="2"
                                placeholder="Enter message"></textarea>
                            <div *ngIf="incomingCallForm.controls['callDiscussion'].errors && !incomingCallForm.controls['callDiscussion'].pristine "
                                class="error-msg1">
                                <div [hidden]="!incomingCallForm.controls['callDiscussion'].errors.required">Call
                                    Discussion is required.</div>
                            </div>

                        </div>

                    </form>

                    <div class="col-md-6" style="text-align: end;">
                        <button mdbBtn *ngIf="basicTicketInformation?.NoofDays > 30 && basicTicketInformation?.EmpID !== empId && basicTicketInformation?.PaidSatus == 0; else incoming"
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                            style="width:auto" mdbWavesEffect type="submit"
                            (click)="submitIncomingForm(incomingCallForm.value, true)"
                            [disabled]="!incomingCallForm.valid">INCOMING CALL / Assign me</button>
                        <ng-template #incoming>
                            <button mdbBtn
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                            style="width:auto" mdbWavesEffect type="submit"
                            (click)="submitIncomingForm(incomingCallForm.value, false)"
                            [disabled]="!incomingCallForm.valid">INCOMING CALL</button>
                        </ng-template>
                    </div>
                    <div class="col-md-6" style="text-align: start;">
                        <p style="padding-top: 5%;cursor: pointer;" (click)="closeViewTicketModal()"> <span>CLOSE</span>
                        </p>
                    </div>
                </div>

                <div class="row ka-em-view-content" id="tab-content" *ngIf="ticketViewTab == 3"
                    style="height: 340px !important;">
                    <form class="" [formGroup]="outGoingCallForm">

                        <!-- <p class="h4 mb-4 ka-section-head-text ka-login-header-text">Admin Login</p> -->

                        <!-- Name -->
                        <div class="row mt-2">
                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="defaultContactFormName">
                                    Call Received By<span class="ka-em-requried">*</span></label>
                                <select #outgoingRelationSelect class="browser-default custom-select" id="relationID"
                                    formControlName="relationID"
                                    (change)="selectedOutGoingCallRelation(outgoingRelationSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of callsFrom" [ngValue]="call.value">
                                        <p>{{call['label']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="outGoingCallForm.controls['relationID'].errors && !outGoingCallForm.controls['relationID'].pristine"
                                    class="error-msg1">
                                    <div [hidden]="!outGoingCallForm.controls['relationID'].errors.required">Call
                                        Received
                                        From is required.</div>

                                </div>
                            </div>
                            <div class="col-md-6 ">

                                <label class="text-left ka-float-left " for="relationName">
                                    Relation Name<span class="ka-em-requried">*</span></label>
                                <input type="text" formControlName="relationName" id="relationName" mdbInput
                                    class="form-control " placeholder="Enter Relation Name">
                                <div *ngIf="outGoingCallForm.controls['relationName'].errors && !outGoingCallForm.controls['relationName'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!outGoingCallForm.controls['relationName'].errors.required">Relation
                                        Name
                                        is required.</div>
                                </div>
                            </div>

                        </div>

                        <div class="row mt-2">
                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="defaulvoiceCallType">
                                    Voice Call Type<span class="ka-em-requried">*</span></label>
                                <select #OutgoingVoiceCallSelect class="browser-default custom-select"
                                    id="voiceCallType" formControlName="voiceCallType"
                                    (change)="selectedOutgoingVoiceCallType(OutgoingVoiceCallSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of voiceCallsType" [ngValue]="call.value">
                                        <p>{{call['label']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="outGoingCallForm.controls['voiceCallType'].errors && !outGoingCallForm.controls['voiceCallType'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!outGoingCallForm.controls['voiceCallType'].errors.required">Call
                                        Voice is required.</div>

                                </div>
                            </div>

                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="defaulphoneNum">
                                    Call Telephone Number<span class="ka-em-requried">*</span></label>
                                <select #outgoingPhoneSelect class="browser-default custom-select" id="phoneNum"
                                    formControlName="phoneNum"
                                    (change)="selectedOutgoingPhone(outgoingPhoneSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let telePhone of callTelephoneNumbers" [ngValue]="telePhone">
                                        <p>{{hideFewNumbersInMobileNum(telePhone)}}</p>
                                    </option>
                                </select>
                                <div *ngIf="outGoingCallForm.controls['phoneNum'].errors && !outGoingCallForm.controls['phoneNum'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!outGoingCallForm.controls['phoneNum'].errors.required">Call
                                        Telephone Number required.</div>
                                </div>

                            </div>

                        </div>
                        <div class="row mt-2">
                            <div class="col-md-8">
                                <label class="text-left ka-float-left " for="defaultContactFormName">Call Result<span
                                        class="ka-em-requried">*</span></label>
                                <div class="button-holder">
                                    <input type="radio" class="regular-radio" formControlName="callResult" value="417"
                                        id="callResult-Success"><label for="callResult-Success"
                                        [ngClass]="{ 'is-invalid': outGoingCallForm && outGoingCallForm.controls['callResult'].errors }">Successfull</label><br>
                                    <input type="radio" class="regular-radio" formControlName="callResult" value="418"
                                        id="callResult-unSuccess"><label for="callResult-unSuccess"
                                        [ngClass]="{ 'is-invalid': outGoingCallForm && outGoingCallForm.controls['callResult'].errors }">UnSuccessfull</label><br>
                                    <input type="radio" class="regular-radio" formControlName="callResult" value="587"
                                        id="callResult-didNotCall"><label for="callResult-didNotCall"
                                        [ngClass]="{ 'is-invalid': outGoingCallForm && outGoingCallForm.controls['callResult'].errors }">Did
                                        Not Call</label><br>
                                </div>
                            </div>
                            <div class="col-md-4"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label class="text-left ka-float-left " for="defaulvoiceCallType">
                                    Call Response Type</label>
                                <select #incomingVoiceCallSelect
                                    class="browser-default custom-select"
                                    formControlName="MarketingTicketStatus">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of responseTypeArray"
                                        [ngValue]="call.id">
                                        <p>{{call['value']}}</p>
                                    </option>
                                </select>
                                <!-- <div *ngIf="outGoingCallForm.controls['MarketingTicketStatus'].errors && !outGoingCallForm.controls['MarketingTicketStatus'].pristine "
                                    class="error-msg1">
                                    <div
                                        [hidden]="!outGoingCallForm.controls['MarketingTicketStatus'].errors.required">
                                        Response Cal is required.</div>

                                </div> -->
                            </div>
                            <div class="col-md-6 customMultiSelect">

                            </div>


                        </div>

                        <div class="row mt-2" style="padding-left: 2%;">

                            <label class="text-left ka-float-left " for="defaultContactFormName">Call Discussion<span
                                    class="ka-em-requried">*</span></label>

                            <textarea type="text" formControlName="callDiscussion" class="form-control" rows="2"
                                placeholder="Enter message"></textarea>
                            <div *ngIf="outGoingCallForm.controls['callDiscussion'].errors && !outGoingCallForm.controls['callDiscussion'].pristine "
                                class="error-msg1">
                                <div [hidden]="!outGoingCallForm.controls['callDiscussion'].errors.required">Call
                                    Discussion is required.</div>
                            </div>

                        </div>

                    </form>

                    <div class="col-md-6 mt-2" style="text-align: end;">
                        <button mdbBtn *ngIf="basicTicketInformation?.NoofDays > 30 && basicTicketInformation?.EmpID !== empId && basicTicketInformation?.PaidSatus == 0; else outgoing"
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                            style="width:auto" mdbWavesEffect type="submit"
                            (click)="submitOutGoingForm(outGoingCallForm.value, true)"
                            [disabled]="!outGoingCallForm.valid">OUTGOING CALL / Assign me</button>
                        <ng-template #outgoing>
                            <button mdbBtn
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                            style="width:auto" mdbWavesEffect type="submit"
                            (click)="submitOutGoingForm(outGoingCallForm.value, false)"
                            [disabled]="!outGoingCallForm.valid">OUTGOING CALL</button>
                        </ng-template>
                    </div>
                    <!-- <div class="col-md-4 mt-2" style="text-align: end;">

                    </div> -->

                    <div class="col-md-6" style="text-align: start;">
                        <p style="padding-top: 5%;cursor: pointer;" (click)="closeViewTicketModal()"> <span>CLOSE</span>
                        </p>
                    </div>


                </div>
                <div class="row ka-em-view-content" id="tab-content" *ngIf="ticketViewTab == 4">
                    <form class="" [formGroup]="internalMemoForm">
                        <div class="row">
                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="assignReassign">
                                    Assign/Re-Assign<span class="ka-em-requried">*</span></label>
                                <select #internalMemoSelect class="browser-default custom-select" id="assignReAssign"
                                    formControlName="assignReAssign"
                                    (change)="selectedInternalMemoEmpID(internalMemoSelect.value)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let call of assignReassignArray" [ngValue]="call['ID']">
                                        <p>{{call['NAME']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="internalMemoForm.controls['assignReAssign'].errors && !internalMemoForm.controls['assignReAssign'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!internalMemoForm.controls['assignReAssign'].errors.required">
                                        Assign/Re-Assign is required.</div>

                                </div>
                            </div>
                            <div class="col-md-6 ">

                            </div>

                        </div>

                        <div class="row mt-2" style="padding-left: 2%; padding-top: 1%;">

                            <label class="text-left ka-float-left " for="defaultContactFormName">Memo<span
                                    class="ka-em-requried">*</span></label>

                            <textarea type="text" formControlName="memo" class="form-control" rows="2"
                                placeholder="Enter message"></textarea>
                            <div *ngIf="internalMemoForm.controls['memo'].errors && !internalMemoForm.controls['memo'].pristine "
                                class="error-msg1">
                                <div [hidden]="!internalMemoForm.controls['memo'].errors.required">Memo is required.
                                </div>
                            </div>

                        </div>
                    </form>
                    <div class="col-md-6" style="text-align: end;">
                        <button mdbBtn
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                            style="width:auto" mdbWavesEffect type="submit"
                            (click)="submitInternalMemoForm(internalMemoForm.value)"
                            [disabled]="!internalMemoForm.valid"> INTERNAL MEMO</button>
                    </div>

                    <div class="col-md-6" style="text-align: start;">
                        <p style="padding-top: 5%;cursor: pointer;" (click)="closeViewTicketModal()"> <span>CLOSE</span>
                        </p>
                    </div>
                </div>



                <div class="row ka-em-view-content" id="tab-content" *ngIf="ticketViewTab == 5">
                    <form class="" [formGroup]="closeTicketForm">
                        <div class="row">
                            <div class="col-md-6 customMultiSelect">
                                <label class="text-left ka-float-left " for="replyType">
                                    Reply Type<span class="ka-em-requried">*</span></label>
                                <select #replyTypeSelect class="browser-default custom-select" id="replyType"
                                    formControlName="replyType" (ngModelChange)="selectedReplyType($event)">
                                    <option ngValue="">Select</option>
                                    <option *ngFor="let replyValue of replyTypeArray" [ngValue]="replyValue['ID']">
                                        <p>{{replyValue['Heder']}}</p>
                                    </option>
                                </select>
                                <div *ngIf="closeTicketForm.controls['replyType'].errors && !closeTicketForm.controls['replyType'].pristine "
                                    class="error-msg1">
                                    <div [hidden]="!closeTicketForm.controls['replyType'].errors.required">Reply Type is
                                        required.</div>

                                </div>
                            </div>
                            <div class="col-md-6 ">

                            </div>

                        </div>

                        <div class="row mt-2" style="padding-left: 2%; padding-top: 1%;">

                            <label class="text-left ka-float-left " for="defaultContactFormName">Reason For Close<span
                                    class="ka-em-requried">*</span></label>

                            <textarea type="text" formControlName="reasonForClose" class="form-control" rows="2"
                                placeholder="Enter message"></textarea>
                            <div *ngIf="closeTicketForm.controls['reasonForClose'].errors && !closeTicketForm.controls['reasonForClose'].pristine "
                                class="error-msg1">
                                <div [hidden]="!closeTicketForm.controls['reasonForClose'].errors.required">Reason For
                                    Close is required.</div>
                            </div>

                        </div>
                    </form>
                    <div class="col-md-6" style="text-align: end;">
                        <button mdbBtn
                            class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                            style="width:auto" mdbWavesEffect type="submit"
                            (click)="submitCloseTicketForm(closeTicketForm.value)" [disabled]="!closeTicketForm.valid">
                            CLOSE TICKET</button>
                    </div>
                    <div class="col-md-6" style="text-align: start;">
                        <p style="padding-top: 5%;cursor: pointer;" (click)="closeViewTicketModal()"> <span>CLOSE</span>
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div mdbModal #basicModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeOTPModal()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="m-0 p-0">

                                Mobile verification sent successfully to {{basicTicketInformation['number']}}<br>

                            </p>

                            <div class="action-buttons" style="padding-top: 2%;">
                                <div class="row">
                                    <div class="col-md-8" style="padding-top: 3%;">
                                        Check yes, If you want to verify by you
                                    </div>
                                    <div class="col-md-4" style="padding-top: 3%;">
                                        <div class="row">
                                            <div class="col">
                                                <div class="btn-holder">
                                                    <input type="radio" class="ka-em-radio-btn" value="Yes" id="Yes"
                                                        name="radio"
                                                        (change)="isSeletedYesOrNo($event.target.value)"><label
                                                        for="Yes" class="ka-em-rbn-label">Yes</label>
                                                </div>

                                            </div>
                                            <div class="col">
                                                <div class="btn-holder">
                                                    <input type="radio" class="ka-em-radio-btn" value="No" id="No"
                                                        name="radio"
                                                        (change)="isSeletedYesOrNo($event.target.value)"><label for="No"
                                                        class="ka-em-rbn-label">No</label>
                                                </div>

                                            </div>
                                        </div>

                                    </div>


                                </div>
                                <div class="row" *ngIf="isSelectedToSendOTP==='Yes'">
                                    <form class="" [formGroup]="otpForm">
                                        <!-- <label class="text-left ka-float-left "
                                            for="defaultContactFormName">
                                            OTP</label>
                                        <input type="text" formControlName="otp" id="defaultContactFormName" mdbInput
                                            class="form-control " placeholder="Enter OTP" required>
                                        <div *ngIf="otpForm.controls['otp'].errors && !otpForm.controls['otp'].pristine "
                                            class="error-msg1">
                                            <div [hidden]="!otpForm.controls['otp'].errors.required">OTP is required.
                                            </div>
                                            <div [hidden]="!otpForm.controls['otp'].errors.pattern">
                                                Enter the Valid OTP
                                            </div>
                                        </div> -->

                                        <label class="mt-3">Enter OTP<span class="ka-em-requried">*</span></label>
                                        <div class="row mt-3  ka-otp-input" style="justify-content: center;">


                                            <div class="row ka-otp-input">
                                                <div class="col-2">
                                                    <input type="number" #otp1 maxlength="1" max="1"
                                                        class="form-control" formControlName="otp1"
                                                        (keypress)="omit_special_char_withNumbers_custom($event)"
                                                        (input)="onInputEntry($event, otp2, undefined, 'otp1')"
                                                        (focus)="onFocusInput($event)"
                                                        [ngClass]="{ 'ka-invlid-textBox':  otpForm.controls['otp1'].errors }">
                                                </div>
                                                <div class="col-2">
                                                    <input type="number" #otp2 maxlength="1" max="1"
                                                        class="form-control" formControlName="otp2"
                                                        (keypress)="omit_special_char_withNumbers_custom($event)"
                                                        [ngClass]="{ 'ka-invlid-textBox':   otpForm.controls['otp2'].errors }"
                                                        (input)="onInputEntry($event, otp3,otp1,'otp2')">
                                                </div>
                                                <div class="col-2">
                                                    <input type="number" #otp3 maxlength="1" max="1"
                                                        class="form-control" formControlName="otp3"
                                                        (keypress)="omit_special_char_withNumbers_custom($event)"
                                                        [ngClass]="{ 'ka-invlid-textBox': otpForm.controls['otp3'].errors }"
                                                        (input)="onInputEntry($event, otp4,otp2,'otp3')">
                                                </div>
                                                <div class="col-2">
                                                    <input type="number" #otp4 maxlength="1" max="1"
                                                        class="form-control" formControlName="otp4"
                                                        (keypress)="omit_special_char_withNumbers_custom($event)"
                                                        [ngClass]="{ 'ka-invlid-textBox':  otpForm.controls['otp4'].errors }"
                                                        (input)="onInputEntry($event, otp5,otp3,'otp4')">
                                                </div>
                                                <div class="col-2">
                                                    <input type="number" max="1" #otp5 maxlength="1"
                                                        class="form-control" formControlName="otp5"
                                                        (keypress)="omit_special_char_withNumbers_custom($event)"
                                                        [ngClass]="{ 'ka-invlid-textBox':   otpForm.controls['otp5'].errors }"
                                                        (input)="lastInput($event,otp4,'otp5')">
                                                </div>
                                                <div *ngIf="otpForm.controls['otp5'].errors" style="margin-top: 0; position: inherit !important; text-align: left !important;
                                                     margin-left: 27px;" class="invalid-feedback">
                                                    <div *ngIf="otpForm.controls['otp5'].errors.required">
                                                        OTP required to verify your mobile number
                                                    </div>
                                                </div>

                                            </div>
                                            <div>

                                            </div>

                                        </div>


                                        <button mdbBtn
                                            class="ka-white-button tButton ka-btn-primary btn-success btn ka-custom-button-login mb-3"
                                            mdbWavesEffect type="submit" [disabled]="!otpForm.valid"
                                            (click)="verifyMobileOtp()">Submit</button>
                                    </form>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>

</div>


<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{responseMessage}} </p>

                            <div class="action-buttons">
                                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                </button>



                            </div>

                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>

<div mdbModal #reasonModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
    aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content" *ngIf="!showMobileOrEmail">
            <b style="text-align: center;margin: 10px;">Please provide the reason to view Contact details</b>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeReasonDialog()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <form class="row text-left" [formGroup]="reasonForm" (ngSubmit)="reasonToView($event)">
                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <!-- <textarea name="" id="" formControlName="reason" style="border: 1px solid lightgray;" cols="50" rows="3"></textarea> -->
                            <div class="row mb-3" style="justify-content: center; display: flex;" >


                                <select id="name" class="form-select ka-dropdown-singleSelect col-9" formControlName="reason" aria-label="Default select example">
                                    <option  class="select-option" [ngValue]="null" disabled selected hidden>Select reason to view contact</option>
                                    <option class="select-option" *ngFor="let reason of callReasonArray" [ngValue]="reason">{{reason.value}}</option>
                                </select>


                            </div>

                            <div style="display: flex; justify-content: center; cursor: pointer;">
                                <button class="btn btn-primary" type="submit" [disabled]="reasonForm.invalid">Submit</button>
                                <p style="cursor: pointer;" (click)="closeReasonDialog()" style="padding-top: 3%;
                                 padding-left: 2%;"> <span>Cancel</span></p>
                            </div>


                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </form>
        </div>
        <div class="modal-content" *ngIf="showMobileOrEmail">
            <b style="text-align: center;margin: 10px;">Contact Details</b>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeReasonDialog()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <form class="row text-left" [formGroup]="reasonForm" (ngSubmit)="reasonToView($event)">
                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            {{responseMessage}}

                            <div style="display: flex; justify-content: center; cursor: pointer;">
                                <p style="cursor: pointer;" (click)="closeReasonDialog()" style="padding-top: 3%;
                                 padding-left: 2%;"> <span>Cancel</span></p>
                            </div>


                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </form>
        </div>


    </div>
</div>
<div mdbModal #contactViewModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="contactViewModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">
                        <div class="col-md-12 rmDetailsSectionPopup viewAllMobilenumbers" *ngFor="let cancdidateContactDetails of cancdidateContactDetails ">
                            <span *ngIf="cancdidateContactDetails?.Number">{{cancdidateContactDetails.Relation}} : {{cancdidateContactDetails?.Number}} </span>
                            <!-- <span *ngIf="cancdidateContactDetails?.Candidatelandlinewithcode">Primary Alt Contact : {{cancdidateContactDetails?.Candidatelandlinewithcode}} </span> -->
                        </div>

                        <div class="action-buttons" style="margin: 0 auto;">
                            <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                mdbWavesEffect type="submit" (click)="contactViewModal.hide()">ok
                            </button>



                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>
<app-img-preview *ngIf="isPreviewClicked" (closeEventTrigger)="closeModalPreviewImage($event)"
    [previewImgArray]="previewImgArray"></app-img-preview>
<app-remainder [isRemainderActive]="isRemainderActive" [profileId]="profileId" [remainderDateTime]="remainderDateTime"
    [remainderId]="remainderId" [empId]="empId" [ticketId]="modifiedId" (resetRemainderValues)=resetReaminder($event)>
</app-remainder>
